import React, { useState } from 'react';

// YouTube 비디오 ID 추출 함수
const extractVideoId = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : null;
};

// YouTube oEmbed API를 사용하여 비디오 정보 가져오기
const getYouTubeEmbed = async (videoId) => {
  try {
    const response = await fetch(`https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`);
    if (response.ok) {
      return await response.json();
    }
  } catch (error) {
    console.error('YouTube oEmbed API 호출 실패:', error);
  }
  return null;
};

const YoutubeSearchApi = () => {
  const [formData, setFormData] = useState({
    type: 'video', // 기본값으로 video 타입 설정
    maxResults: '10' // 기본값으로 10개 결과 설정
  });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [videoPreviews, setVideoPreviews] = useState({});
  const [multiselectOpen, setMultiselectOpen] = useState({});
  const [copyStatus, setCopyStatus] = useState({});
  const [constraintAlerts, setConstraintAlerts] = useState({});

  const parameterConfigs = [
    {
      name: 'q',
      label: 'Search Query',
      description: '검색할 키워드나 구문을 입력합니다. 비워두면 카테고리만으로 검색합니다.',
      type: 'text',
      required: false,
      placeholder: '검색할 키워드를 입력하세요 (선택사항)'
    },
    {
      name: 'type',
      label: 'Type',
      description: '검색할 리소스 유형을 지정합니다. 여러 유형을 쉼표로 구분할 수 있습니다.',
      type: 'select',
      required: false,
      options: [
        { value: 'video', label: 'video (동영상)' },
        { value: 'channel', label: 'channel (채널)' },
        { value: 'playlist', label: 'playlist (재생목록)' },
        { value: 'video,channel', label: 'video,channel (동영상+채널)' },
        { value: 'video,playlist', label: 'video,playlist (동영상+재생목록)' },
        { value: 'channel,playlist', label: 'channel,playlist (채널+재생목록)' },
        { value: 'video,channel,playlist', label: 'video,channel,playlist (모든 타입)' }
      ]
    },
    {
      name: 'videoCategoryId',
      label: 'Video Category ID',
      description: '특정 카테고리의 동영상만 검색합니다. 여러 카테고리를 선택할 수 있습니다. YouTube 동영상 카테고리 ID를 사용합니다.',
      type: 'checkbox',
      required: false,
      options: [
        { value: '1', label: '1 (영화 및 애니메이션)' },
        { value: '2', label: '2 (자동차)' },
        { value: '10', label: '10 (음악)' },
        { value: '15', label: '15 (애완동물 및 동물)' },
        { value: '17', label: '17 (스포츠)' },
        { value: '19', label: '19 (여행 및 이벤트)' },
        { value: '20', label: '20 (게임)' },
                 { value: '22', label: '22 (인물 및 블로그)' },
         { value: '23', label: '23 (코미디)' },
         { value: '24', label: '24 (엔터테인먼트)' },
         { value: '25', label: '25 (뉴스 및 정치)' },
         { value: '26', label: '26 (스타일 및 뷰티)' },
         { value: '27', label: '27 (교육)' },
         { value: '28', label: '28 (과학 및 기술)' },
         { value: '29', label: '29 (비영리 및 활동)' },
         { value: '30', label: '30 (영화)' },
         { value: '31', label: '31 (애니메이션)' },
         { value: '32', label: '32 (액션/어드벤처)' },
         { value: '33', label: '33 (클래식)' },
                  { value: '34', label: '34 (다큐멘터리)' },
                  { value: '35', label: '35 (드라마)' },
                  { value: '36', label: '36 (가족)' },
                  { value: '37', label: '37 (외국어)' },
                  { value: '38', label: '38 (공포)' },
                  { value: '39', label: '39 (SF 및 판타지)' },
                  { value: '40', label: '40 (스릴러)' },
                  { value: '41', label: '41 (단편)' },
                  { value: '42', label: '42 (쇼)' },
                  { value: '43', label: '43 (예고편)' },
         { value: '44', label: '44 (뮤직비디오)' }
      ]
    },
    {
      name: 'order',
      label: 'Order',
      description: '검색 결과의 정렬 순서를 지정합니다. 여러 개를 선택할 수 있습니다.',
      type: 'multiselect',
      required: false,
      options: [
        { value: 'relevance', label: 'relevance (관련성 순)' },
        { value: 'date', label: 'date (업로드 날짜 순)' },
        { value: 'rating', label: 'rating (평점 순)' },
        { value: 'title', label: 'title (제목 순)' },
        { value: 'videoCount', label: 'videoCount (동영상 수 순)' },
        { value: 'viewCount', label: 'viewCount (조회수 순)' }
      ]
    },
    {
      name: 'regionCode',
      label: 'Region Code',
      description: '지정된 지역의 검색 결과를 반환합니다. ISO 3166-1 alpha-2 국가 코드를 사용합니다.',
      type: 'select',
      required: false,
      options: [
        { value: 'KR', label: 'KR (한국)' },
        { value: 'US', label: 'US (미국)' },
        { value: 'JP', label: 'JP (일본)' },
        { value: 'GB', label: 'GB (영국)' },
        { value: 'CA', label: 'CA (캐나다)' },
        { value: 'AU', label: 'AU (호주)' },
        { value: 'DE', label: 'DE (독일)' },
        { value: 'FR', label: 'FR (프랑스)' },
        { value: 'IN', label: 'IN (인도)' },
        { value: 'BR', label: 'BR (브라질)' }
      ]
    },
    {
      name: 'maxResults',
      label: 'Max Results',
      description: '반환할 최대 결과 수를 지정합니다. 기본값은 5, 최대값은 50입니다.',
      type: 'select',
      required: false,
      options: [
        { value: '5', label: '5개' },
        { value: '10', label: '10개' },
        { value: '15', label: '15개' },
        { value: '20', label: '20개' },
        { value: '25', label: '25개' },
        { value: '30', label: '30개' },
        { value: '40', label: '40개' },
        { value: '50', label: '50개' }
      ]
    },
    {
      name: 'videoDuration',
      label: 'Video Duration',
      description: '동영상 길이에 따라 필터링합니다. short(4분 미만), medium(4-20분), long(20분 이상)',
      type: 'select',
      required: false,
      options: [
        { value: 'short', label: 'short (4분 미만)' },
        { value: 'medium', label: 'medium (4-20분)' },
        { value: 'long', label: 'long (20분 이상)' }
      ]
    },
    {
      name: 'videoDefinition',
      label: 'Video Definition',
      description: '동영상 해상도에 따라 필터링합니다. high(HD), standard(SD)',
      type: 'select',
      required: false,
      options: [
        { value: 'high', label: 'high (HD)' },
        { value: 'standard', label: 'standard (SD)' }
      ]
    },
    {
      name: 'videoCaption',
      label: 'Video Caption',
      description: '자막 유무에 따라 필터링합니다. closedCaption(자막 있음), none(자막 없음)',
      type: 'select',
      required: false,
      options: [
        { value: 'closedCaption', label: 'closedCaption (자막 있음)' },
        { value: 'none', label: 'none (자막 없음)' }
      ]
    },
    {
      name: 'videoLicense',
      label: 'Video License',
      description: '동영상 라이선스 유형에 따라 필터링합니다.',
      type: 'select',
      required: false,
      options: [
        { value: 'creativeCommon', label: 'creativeCommon (크리에이티브 커먼즈)' },
        { value: 'youtube', label: 'youtube (표준 YouTube 라이선스)' }
      ]
    },
    {
      name: 'publishedAfter',
      label: 'Published After',
      description: '이 날짜 이후에 업로드된 콘텐츠만 검색합니다. 8자리 날짜(YYYYMMDD) 또는 ISO 8601 형식을 사용합니다.',
      type: 'text',
      required: false,
      placeholder: '예: 20241220 또는 2024-12-20T00:00:00Z'
    },
    {
      name: 'publishedBefore',
      label: 'Published Before',
      description: '이 날짜 이전에 업로드된 콘텐츠만 검색합니다. 8자리 날짜(YYYYMMDD) 또는 ISO 8601 형식을 사용합니다.',
      type: 'text',
      required: false,
      placeholder: '예: 20241221 또는 2024-12-21T23:59:59Z'
    },
    {
      name: 'safeSearch',
      label: 'Safe Search',
      description: '안전 검색 필터링 수준을 지정합니다.',
      type: 'select',
      required: false,
      options: [
        { value: 'moderate', label: 'moderate (보통)' },
        { value: 'none', label: 'none (제한 없음)' },
        { value: 'strict', label: 'strict (엄격)' }
      ]
    },
    {
      name: 'relevanceLanguage',
      label: 'Relevance Language',
      description: '검색 결과의 관련성을 높이기 위한 언어를 지정합니다.',
      type: 'select',
      required: false,
      options: [
        { value: 'ko', label: 'ko (한국어)' },
        { value: 'en', label: 'en (영어)' },
        { value: 'ja', label: 'ja (일본어)' },
        { value: 'zh', label: 'zh (중국어)' },
        { value: 'es', label: 'es (스페인어)' },
        { value: 'fr', label: 'fr (프랑스어)' },
        { value: 'de', label: 'de (독일어)' },
        { value: 'it', label: 'it (이탈리아어)' },
        { value: 'pt', label: 'pt (포르투갈어)' },
        { value: 'ru', label: 'ru (러시아어)' }
      ]
    },
    {
      name: 'location',
      label: 'Location (위도,경도)',
      description: '지정된 위치 근처의 콘텐츠를 검색합니다. 위도와 경도를 쉼표로 구분합니다.',
      type: 'text',
      required: false,
      placeholder: '예: 37.5665,126.9780 (서울)'
    },
    {
      name: 'locationRadius',
      label: 'Location Radius',
      description: '위치 기반 검색의 반경을 지정합니다. location 파라미터와 함께 사용됩니다.',
      type: 'select',
      required: false,
      options: [
        { value: '1km', label: '1km' },
        { value: '5km', label: '5km' },
        { value: '10km', label: '10km' },
        { value: '25km', label: '25km' },
        { value: '50km', label: '50km' },
        { value: '100km', label: '100km' },
        { value: '500km', label: '500km' },
        { value: '1000km', label: '1000km' }
      ]
    },
    {
      name: 'eventType',
      label: 'Event Type',
      description: '이벤트 유형에 따라 필터링합니다. 라이브 스트림 검색에 유용합니다.',
      type: 'select',
      required: false,
      options: [
        { value: 'completed', label: 'completed (완료됨)' },
        { value: 'live', label: 'live (라이브)' },
        { value: 'upcoming', label: 'upcoming (예정됨)' }
      ]
    },
    {
      name: 'channelId',
      label: 'Channel ID',
      description: '특정 채널에서만 검색합니다. 채널 ID를 입력하세요.',
      type: 'text',
      required: false,
      placeholder: '특정 채널에서만 검색'
    },
    {
      name: 'channelType',
      label: 'Channel Type',
      description: '채널 유형에 따라 필터링합니다.',
      type: 'select',
      required: false,
      options: [
        { value: 'any', label: 'any (모든 채널)' },
        { value: 'show', label: 'show (쇼 채널)' }
      ]
    },
    {
      name: 'topicId',
      label: 'Topic ID',
      description: 'Freebase 주제 ID를 사용하여 특정 주제의 콘텐츠를 검색합니다.',
      type: 'text',
      required: false,
      placeholder: 'Freebase 주제 ID'
    },
    {
      name: 'videoEmbeddable',
      label: 'Video Embeddable',
      description: '외부 사이트 임베드 가능 여부에 따라 필터링합니다.',
      type: 'select',
      required: false,
      options: [
        { value: 'true', label: 'true (임베드 가능)' },
        { value: 'false', label: 'false (임베드 불가)' }
      ]
    },
    {
      name: 'videoSyndicated',
      label: 'Video Syndicated',
      description: '제휴 사이트에서 재생 가능 여부에 따라 필터링합니다.',
      type: 'select',
      required: false,
      options: [
        { value: 'true', label: 'true (제휴 가능)' },
        { value: 'false', label: 'false (제휴 불가)' }
      ]
    },
    {
      name: 'videoDimension',
      label: 'Video Dimension',
      description: '동영상 차원에 따라 필터링합니다. 2D 또는 3D 동영상만 검색합니다.',
      type: 'select',
      required: false,
      options: [
        { value: '2d', label: '2d (2D)' },
        { value: '3d', label: '3d (3D)' }
      ]
    }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // 다중 선택 체크박스 핸들러
  const handleMultiselectChange = (name, value) => {
    setFormData(prev => {
      const currentValues = prev[name] ? prev[name].split(',').filter(v => v.trim()) : [];
      
      if (currentValues.includes(value)) {
        // 값이 이미 있으면 제거
        const newValues = currentValues.filter(v => v !== value);
        return {
          ...prev,
          [name]: newValues.join(',')
        };
      } else {
        // 값이 없으면 추가
        const newValues = [...currentValues, value];
        return {
          ...prev,
          [name]: newValues.join(',')
        };
      }
    });
  };

  // 전체선택/전체해제 핸들러
  const handleSelectAll = (name, options) => {
    setFormData(prev => {
      const currentValues = prev[name] ? prev[name].split(',').filter(v => v.trim()) : [];
      const allValues = options.map(option => option.value);
      
      // 현재 모든 값이 선택되어 있으면 전체 해제, 아니면 전체 선택
      const isAllSelected = allValues.every(value => currentValues.includes(value));
      
      if (isAllSelected) {
        return {
          ...prev,
          [name]: ''
        };
      } else {
        return {
          ...prev,
          [name]: allValues.join(',')
        };
      }
    });
  };

  // 다중 선택 드롭다운 토글
  const toggleMultiselect = (name) => {
    setMultiselectOpen(prev => ({
      ...prev,
      [name]: !prev[name]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const params = new URLSearchParams();
      
      // 빈 값이 아닌 파라미터만 추가
      Object.entries(formData).forEach(([key, value]) => {
        if (value && value.trim() !== '') {
          params.append(key, value.trim());
        }
      });

      const response = await fetch(`/api/admin/YoutubeSearchApi?${params.toString()}`);
      const data = await response.json();

      if (data.success) {
        setResult(data);
        
        // YouTube 비디오 미리보기 가져오기
        if (data.result && data.result.items && data.result.items.length > 0) {
          const previews = {};
          for (const item of data.result.items) {
            if (item.id && item.id.videoId) {
              const embedData = await getYouTubeEmbed(item.id.videoId);
              if (embedData) {
                previews[item.id.videoId] = embedData;
              }
            } else if (item.id && typeof item.id === 'string') {
              const embedData = await getYouTubeEmbed(item.id);
              if (embedData) {
                previews[item.id] = embedData;
              }
            }
          }
          setVideoPreviews(previews);
        }
      } else {
        setError(data.message || 'API 호출 실패');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // 조회 버튼 핸들러 (API 호출만)
  const handleSearch = async () => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const params = new URLSearchParams();
      
      // 빈 값이 아닌 파라미터만 추가
      Object.entries(formData).forEach(([key, value]) => {
        if (value && value.trim() !== '') {
          params.append(key, value.trim());
        }
      });

      const response = await fetch(`/api/admin/YoutubeSearchApi?${params.toString()}`);
      const data = await response.json();

      if (data.success) {
        setResult(data);
        
        // YouTube 비디오 미리보기 가져오기
        if (data.result && data.result.items && data.result.items.length > 0) {
          const previews = {};
          for (const item of data.result.items) {
            if (item.id && item.id.videoId) {
              const embedData = await getYouTubeEmbed(item.id.videoId);
              if (embedData) {
                previews[item.id.videoId] = embedData;
              }
            } else if (item.id && typeof item.id === 'string') {
              const embedData = await getYouTubeEmbed(item.id);
              if (embedData) {
                previews[item.id] = embedData;
              }
            }
          }
          setVideoPreviews(previews);
        }
      } else {
        setError(data.message || 'API 호출 실패');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // 저장 버튼 핸들러 (post 테이블에 저장)
  const handleSave = async () => {
    if (!result || !result.result || !result.result.items) {
      setError('저장할 데이터가 없습니다. 먼저 조회를 실행해주세요.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const saveParams = new URLSearchParams();
      
      // 원본 파라미터들 추가
      Object.entries(formData).forEach(([key, value]) => {
        if (value && value.trim() !== '') {
          saveParams.append(key, value.trim());
        }
      });

      // 저장 요청
      const response = await fetch(`/api/youtube/save-videos?${saveParams.toString()}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          videos: result.result.items,
          params: result.params
        })
      });

      const data = await response.json();

      if (data.success) {
        alert(`성공적으로 ${data.savedCount}개의 동영상을 저장했습니다.`);
      } else {
        setError(data.message || '저장 실패');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // 텍스트 복사 함수
  const handleCopy = async (text, type) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopyStatus(prev => ({ ...prev, [type]: '복사됨' }));
      
      // 2초 후 상태 초기화
      setTimeout(() => {
        setCopyStatus(prev => ({ ...prev, [type]: '' }));
      }, 2000);
    } catch (err) {
      console.error('복사 실패:', err);
      setCopyStatus(prev => ({ ...prev, [type]: '복사 실패' }));
      
      setTimeout(() => {
        setCopyStatus(prev => ({ ...prev, [type]: '' }));
      }, 2000);
    }
  };

  // 제약사항 체크 함수
  const checkConstraints = (name, value) => {
    const newFormData = { ...formData, [name]: value };
    
    // search 엔드포인트 필터 검사
    if ('search' === 'search') {
      // 검색어나 카테고리 중 하나는 있어야 함
      const hasSearchQuery = newFormData.q && newFormData.q.trim() !== '';
      const hasCategory = newFormData.videoCategoryId && newFormData.videoCategoryId.trim() !== '';
      
      if (!hasSearchQuery && !hasCategory && (newFormData.order || newFormData.maxResults || newFormData.regionCode)) {
        const message = `⚠️ 제약사항 알림\n\nSearch API는 검색어(q) 또는 카테고리(videoCategoryId) 중 하나는 필요합니다.\n\n해결 방법:\n1. 검색어를 입력하세요\n2. 카테고리를 선택하세요\n3. 검색어와 카테고리를 모두 사용할 수 있습니다`;
        alert(message);
        setConstraintAlerts(prev => ({ ...prev, [name]: true }));
        return false;
      }
    }

    setConstraintAlerts(prev => ({ ...prev, [name]: false }));
    return true;
  };

  const renderParameterField = (config) => {
    const { name, label, type, options, placeholder, required, description } = config;
    
    if (type === 'checkbox' && options) {
      return (
        <div key={name} className="form-group full-width">
          <label htmlFor={name} className={required ? 'required' : ''}>{label}:</label>
          {description && <div className="parameter-description">{description}</div>}
          <div className="checkbox-group">
            {options.map(option => (
              <label key={option.value} className="checkbox-option">
                <input
                  type="checkbox"
                  value={option.value}
                  checked={formData[name] ? formData[name].split(',').includes(option.value) : false}
                  onChange={(e) => {
                    const currentValues = formData[name] ? formData[name].split(',').filter(v => v.trim()) : [];
                    let newValue;
                    
                    if (e.target.checked) {
                      newValue = [...currentValues, option.value].join(',');
                    } else {
                      newValue = currentValues.filter(v => v !== option.value).join(',');
                    }
                    
                    // 제약사항 체크
                    if (checkConstraints(name, newValue)) {
                      setFormData(prev => ({
                        ...prev,
                        [name]: newValue
                      }));
                    }
                  }}
                />
                <span className="checkbox-label">{option.label}</span>
              </label>
            ))}
          </div>
        </div>
      );
    }
    
    if (type === 'multiselect' && options) {
      const currentValues = formData[name] ? formData[name].split(',').filter(v => v.trim()) : [];
      const isOpen = multiselectOpen[name] || false;
      
      return (
        <div key={name} className="form-group">
          <label htmlFor={name} className={required ? 'required' : ''}>{label}:</label>
          {description && <div className="parameter-description">{description}</div>}
          <div className="multiselect-container">
            <div 
              className="multiselect-trigger"
              onClick={() => toggleMultiselect(name)}
            >
              <span className="multiselect-display">
                {currentValues.length > 0 
                  ? `${currentValues.length}개 선택됨` 
                  : '선택하세요'
                }
              </span>
              <span className="multiselect-arrow">▼</span>
            </div>
            {isOpen && (
              <div className="multiselect-dropdown">
                {/* 전체선택 체크박스 */}
                <label className="multiselect-option select-all-option">
                  <input
                    type="checkbox"
                    checked={currentValues.length === options.length && options.length > 0}
                    onChange={() => handleSelectAll(name, options)}
                  />
                  <span className="multiselect-option-text">전체선택</span>
                </label>
                <div className="multiselect-divider"></div>
                {options.map(option => (
                  <label key={option.value} className="multiselect-option">
                    <input
                      type="checkbox"
                      checked={currentValues.includes(option.value)}
                      onChange={() => handleMultiselectChange(name, option.value)}
                    />
                    <span className="multiselect-option-text">{option.label}</span>
                  </label>
                ))}
              </div>
            )}
          </div>
        </div>
      );
    }
    
    if (type === 'select' && options) {
      return (
        <div key={name} className="form-group">
          <label htmlFor={name} className={required ? 'required' : ''}>{label}:</label>
          {description && <div className="parameter-description">{description}</div>}
          <select
            id={name}
            name={name}
            value={formData[name] || ''}
            onChange={(e) => {
              const value = e.target.value;
              if (checkConstraints(name, value)) {
                handleInputChange(e);
              }
            }}
            required={required}
          >
            <option value="">선택하세요</option>
            {options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      );
    }
    
    return (
      <div key={name} className="form-group">
        <label htmlFor={name} className={required ? 'required' : ''}>{label}:</label>
        {description && <div className="parameter-description">{description}</div>}
        <input
          type="text"
          id={name}
          name={name}
          value={formData[name] || ''}
          onChange={(e) => {
            const value = e.target.value;
            if (checkConstraints(name, value)) {
              handleInputChange(e);
            }
          }}
          placeholder={placeholder}
          required={required}
        />
      </div>
    );
  };

  return (
    <div className="youtube-api-tester">
      <div className="page-header">
        <h1>YouTube Search API 테스트</h1>
        <p>YouTube에서 동영상, 채널, 재생목록을 검색하는 API입니다. 키워드 기반 검색과 다양한 필터링 옵션을 제공합니다.</p>
      </div>

      <div className="form-section">
        <h3>API 파라미터 설정</h3>
        <form onSubmit={handleSubmit}>
          <div className="parameters-grid">
            {parameterConfigs.map(renderParameterField)}
          </div>
          
          <div className="form-actions">
            <button 
              type="button" 
              className="search-button"
              onClick={handleSearch}
              disabled={loading}
            >
              {loading ? '실행 중...' : '실행'}
            </button>
            <button 
              type="button" 
              className="submit-button"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? 'API 호출 중...' : 'API 호출'}
            </button>
          </div>
        </form>
      </div>

      {error && (
        <div className="error-section">
          <h3>❌ 오류</h3>
          <div className="error-message">{error}</div>
        </div>
      )}

      {result && (
        <div className="result-section">
          <div className="result-header">
            <h3>✅ API 호출 결과</h3>
            <button 
              type="button" 
              className="save-button"
              onClick={handleSave}
              disabled={loading}
            >
              {loading ? '저장 중...' : '📥 Post 테이블에 저장'}
            </button>
          </div>
          
          <div className="result-info">
            <div className="info-item">
              <strong>엔드포인트:</strong> {result.endpoint}
            </div>
            <div className="info-item">
              <strong>총 결과 수:</strong> {result.result.totalResults}
            </div>
            <div className="info-item">
              <strong>페이지당 결과 수:</strong> {result.result.resultsPerPage}
            </div>
            <div className="info-item">
              <strong>실제 반환된 항목:</strong> {result.result.items.length}개
            </div>
          </div>

          {/* YouTube 미리보기 섹션 */}
          {result.result.items && result.result.items.length > 0 && (
            <div className="youtube-previews">
              <h4>🎬 YouTube 미리보기 ({result.result.items.length}개)</h4>
              <div className="video-grid">
                {result.result.items.map((item, index) => {
                  const videoId = item.id?.videoId || (typeof item.id === 'string' ? item.id : null);
                  const preview = videoId ? videoPreviews[videoId] : null;
                  
                  if (videoId && preview) {
                    // YouTube API에서 가져온 원본 데이터에서 추가 정보 추출
                    const snippet = item.snippet || {};
                    const statistics = item.statistics || {};
                    
                    // 조회수 포맷팅
                    const formatViewCount = (count) => {
                      if (!count) return '0';
                      const num = parseInt(count);
                      if (num >= 1000000) {
                        return (num / 1000000).toFixed(1) + 'M';
                      } else if (num >= 1000) {
                        return (num / 1000).toFixed(1) + 'K';
                      }
                      return num.toString();
                    };

                    // 날짜 포맷팅
                    const formatDate = (dateString) => {
                      if (!dateString) return '';
                      const date = new Date(dateString);
                      return date.toLocaleDateString('ko-KR', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                      });
                    };

                    return (
                      <div key={index} className="video-preview-item">
                        <div className="video-thumbnail">
                          <img 
                            src={snippet.thumbnails?.high?.url || preview.thumbnail_url} 
                            alt={preview.title}
                          />
                        </div>
                        <div className="video-info">
                          <h5>{preview.title}</h5>
                          <p className="video-author">{preview.author_name}</p>
                          <div className="video-stats">
                            {snippet.publishedAt && (
                              <div className="video-stat">
                                <span>📅</span>
                                <span>{formatDate(snippet.publishedAt)}</span>
                              </div>
                            )}
                            {statistics.viewCount && (
                              <div className="video-stat">
                                <span>👁️</span>
                                <span>{formatViewCount(statistics.viewCount)} 조회</span>
                              </div>
                            )}
                            {statistics.likeCount && (
                              <div className="video-stat">
                                <span>👍</span>
                                <span>{formatViewCount(statistics.likeCount)} 좋아요</span>
                              </div>
                            )}
                            {statistics.commentCount && (
                              <div className="video-stat">
                                <span>💬</span>
                                <span>{formatViewCount(statistics.commentCount)} 댓글</span>
                              </div>
                            )}
                            {snippet.duration && (
                              <div className="video-stat">
                                <span>⏱️</span>
                                <span>{snippet.duration}</span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  }
                  return null;
                })}
              </div>
            </div>
          )}

          <div className="parameters-display">
            <div className="display-header">
              <h4>사용된 파라미터:</h4>
              <button 
                type="button" 
                className="copy-button"
                onClick={() => handleCopy(JSON.stringify(result.params, null, 2), 'params')}
                title="파라미터 복사"
              >
                📋 {copyStatus.params || '복사'}
              </button>
            </div>
            <pre>{JSON.stringify(result.params, null, 2)}</pre>
          </div>

          <div className="results-display">
            <div className="display-header">
              <h4>결과 데이터 (조회수, 좋아요, 댓글 수 포함):</h4>
              <button 
                type="button" 
                className="copy-button"
                onClick={() => handleCopy(JSON.stringify(result.result, null, 2), 'results')}
                title="결과 데이터 복사"
              >
                📋 {copyStatus.results || '복사'}
              </button>
            </div>
            
            {/* 포맷팅된 통계 정보 미리보기 */}
            {result.result.items && result.result.items.length > 0 && (
              <div className="stats-preview">
                <h5>📊 통계 정보 미리보기:</h5>
                <div className="stats-summary">
                  {result.result.items.map((item, index) => {
                    const snippet = item.snippet || {};
                    const statistics = item.statistics || {};
                    
                    // 조회수 포맷팅
                    const formatViewCount = (count) => {
                      if (!count) return '0';
                      const num = parseInt(count);
                      if (num >= 1000000) {
                        return (num / 1000000).toFixed(1) + 'M';
                      } else if (num >= 1000) {
                        return (num / 1000).toFixed(1) + 'K';
                      }
                      return num.toString();
                    };

                    return (
                      <div key={index} className="stat-item">
                        <strong>{index + 1}. {snippet.title || '제목 없음'}</strong>
                        <div className="stat-details">
                          {statistics.viewCount && (
                            <span className="stat-badge view-count">👁️ {formatViewCount(statistics.viewCount)} 조회</span>
                          )}
                          {statistics.likeCount && (
                            <span className="stat-badge like-count">👍 {formatViewCount(statistics.likeCount)} 좋아요</span>
                          )}
                          {statistics.commentCount && (
                            <span className="stat-badge comment-count">💬 {formatViewCount(statistics.commentCount)} 댓글</span>
                          )}
                          {!statistics.viewCount && !statistics.likeCount && !statistics.commentCount && (
                            <span className="stat-badge no-stats">📊 통계 정보 없음</span>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            
            <pre>{JSON.stringify(result.result, null, 2)}</pre>
          </div>
        </div>
      )}

      {/* 제약사항 안내 섹션 */}
      <div className="constraints-section">
        <h3>📋 YouTube API 제약사항</h3>
        <div className="constraints-content">
          <div className="constraint-group">
            <h4>🔍 Search API 제약사항</h4>
            <ul>
              <li><strong>검색어 선택:</strong> q 파라미터는 선택사항입니다. 비워두면 카테고리만으로 검색 가능합니다.</li>
              <li><strong>지역 제한:</strong> regionCode는 검색 결과에 영향을 줄 수 있습니다.</li>
              <li><strong>정렬 옵션:</strong> order 파라미터는 relevance, date, rating, title, viewCount, videoCount 중 선택 가능합니다.</li>
              <li><strong>카테고리 검색:</strong> videoCategoryId만으로도 검색이 가능하여 더 포괄적인 결과를 얻을 수 있습니다.</li>
            </ul>
          </div>
          
          <div className="constraint-group">
            <h4>📋 일반 제약사항</h4>
            <ul>
              <li><strong>API 할당량:</strong> 일일 10,000 유닛 제한이 있습니다.</li>
              <li><strong>최대 결과 수:</strong> maxResults는 1-50 사이의 값이어야 합니다.</li>
              <li><strong>지역 코드:</strong> ISO 3166-1 alpha-2 형식(예: KR, US, JP)을 사용해야 합니다.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YoutubeSearchApi;
